module.exports = new __parcel__URL__("scratch02.6bf80089.mp3").toString();